import type { SettingsTabItem } from "./SettingsLayout";

export const SETTINGS_ROUTES = {
  vehicleSettings: "/administration/settings/vehicle-settings",
  tireSettings: "/administration/settings/tire-settings",
  unitsSettings: "/administration/settings/units-settings",
  customersSettings: "/administration/settings/customers-settings",
} as const;

export const vehicleSettingsTabs: SettingsTabItem[] = [
  {
    key: "brand",
    labelKey: "brand",
    path: "/administration/settings/vehicle-settings/brand",
  },
  {
    key: "model",
    labelKey: "model",
    path: "/administration/settings/vehicle-settings/model",
  },
  {
    key: "type",
    labelKey: "settings_type_tab",
    path: "/administration/settings/vehicle-settings/type",
  },
];

export const tireSettingsTabs: SettingsTabItem[] = [
  {
    key: "brand",
    labelKey: "brand",
    path: "/administration/settings/tire-settings/brand",
  },
  {
    key: "model",
    labelKey: "model",
    path: "/administration/settings/tire-settings/model",
  },
  {
    key: "measure",
    labelKey: "measure",
    path: "/administration/settings/tire-settings/measure",
  },
  {
    key: "preset",
    labelKey: "preset",
    path: "/administration/settings/tire-settings/preset",
  },
];

export const unitsSettingsTabs: SettingsTabItem[] = [
  {
    key: "brand",
    labelKey: "brand",
    path: "/administration/settings/units-settings/brand",
  },
  {
    key: "model",
    labelKey: "model",
    path: "/administration/settings/units-settings/model",
  },
];

export const customersSettingsTabs: SettingsTabItem[] = [
  {
    key: "type",
    labelKey: "settings_type_tab",
    path: "/administration/settings/customers-settings/type",
  },
  {
    key: "source",
    labelKey: "source",
    path: "/administration/settings/customers-settings/source",
  },
  {
    key: "position",
    labelKey: "position",
    path: "/administration/settings/customers-settings/position",
  },
];
